<template>
  <div>
    <b-row>
      <b-col md="12">
        <app-timeline>
          <app-timeline-item
            v-for="(data, i) in timelineData"
            :key="i"
            :title="data.title"
            :subtitle="data.description"
            :icon="data.icon"
            :time="data.time"
            :color="data.color"
            :added-by="data.addedBy"
          />

        </app-timeline>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from '@axios'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
// import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  name: 'EsTimeline',
  components: {
    AppTimeline,
    // AppTimelineItem,
  },
  props: {
    esid: { type: String, default: '' },
    inace: { type: String, default: '' },
    customerid: { type: Object, default: null },
    et: { type: String, default: '' },
    mot: { type: String, default: '' },
  },
  data() {
    return {
      item: [],
      timelineData: [],
    }
  },
  beforeMount() {
    axios.defaults.headers.common.DBContext = this.$store.state.user.AppActiveUser.ABIDbContext
    this.LoadAll()
  },
  methods: {
    LoadAll() {
      Promise.all([this.LoadingStart(), this.LoadTime()]).then(() => {
        this.LoadingEnd()
      })
    },
    LoadTime() {
      return axios.get(`/entry/${this.esid}/summary/timeline`).then(rowData => {
        this.timelineData = rowData.data
      })
    },
  },
}

</script>
